<template>
    <div>
      <!-- BTC -->
        <!-- 盈利地址数 -->
          <div v-if="prop1 == `B01-1-1`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">Address in Profit = total address where Price >= Price_created</p>
             </el-row>
          </div>
          <!-- 亏损地址数 -->
          <div v-if="prop1 == `B01-1-2`">
                <el-row type="flex" justify="center">
                    <p style="font-weight:550;color:rgba(0,0,0,0.7)">Address in Loss = total address where Price ＜ Price_ created</p>
                </el-row>
          </div>
          <!-- 地址盈亏比 -->
          <div v-if="prop1 == `B01-1-3`">
            <!-- 公式 -->
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Percent of Address in Profit =</div>
                    <div>
                        <span>Address in Profit</span>
                        <i style="text-align:center">Total Address</i>
                    </div>
                </section>
            </el-row>
          </div>
          <!-- puell multiple -->
          <div v-if="prop1 == `B02-1-1`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Puell Multiple =</div>
                    <div>
                        <span>Daily Coin Issuance <span style="color:rgba(0,0,0,0.4)"> (USD)</span></span>
                        <span>MA<span style="font-size:12px;border:none">365</span> <span style="color:rgba(0,0,0,0.4);border:none">(Daily Coin Issuance (USD))</span> </span>
                    </div>
                </section>
            </el-row>
         </div>
         <!-- 交易汇率乘数 -->
          <div v-if="prop1 == `B03-1-2`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Fee Ratio Multiple =</div>
                    <div>
                        <span>miner revenue(blocks rewards + transaction fees )</span>
                        <span>transaction fees</span>
                    </div>
                </section>
            </el-row>
         </div>
         <!-- 长期持有者盈利供应量 -->
          <div v-if="prop1 == `B04-1-3`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.7)">Profit for LTH = number of balance where Price > Price_created and Holder Time >= 155days</p>
            </el-row>
        </div>
        <!-- 长期持有者亏损供应量 -->
          <div v-if="prop1 == `B04-1-4`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.7)">Loss for LTH = number of balance where Price  ＜= Price_created and Holder Time >= 155days</p>
            </el-row>
        </div>
        <!-- 长期持有者盈亏比 -->
          <div v-if="prop1 == `B04-1-5`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>PL Ratio for LTH =</div>
                    <div>
                        <span>Profit for LTH </span>
                        <span>Loss for LTH</span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 短期持有者盈利供应量 -->
          <div v-if="prop1 == `B04-1-6`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.7)">Profit for STH = number of balance where Price > Price_created and Holder Time ＜ 155days</p>
            </el-row>
        </div>
        <!-- 短期持有者亏损供应量 -->
          <div v-if="prop1 == `B04-1-7`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.7)">Loss for STH = number of balance where Price ＜= Price_created and Holder Time ＜ 155days</p>
            </el-row>
        </div>
        <!-- 短期持有者盈亏比 -->
          <div v-if="prop1 == `B04-1-8`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>PL Ratio for STH =</div>
                    <div>
                        <span>Profit for STH </span>
                        <span>Loss for STH</span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 短期到长期实现价值比率 -->
          <div v-if="prop1 == `B04-1-10`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>SLRV ratio =</div>
                    <div>
                        <span>HOLDER in 24h </span>
                        <span>HOLDER in 6m~1y</span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 长期持有者 MVRV Ratio -->
          <div v-if="prop1 == `B04-1-11`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>LTH-MVRV =</div>
                    <div>
                        <span> Market Cap <span style="color:rgba(0,0,0,0.4)">(of all UTXOs where age≥155 days)</span> </span>
                        <span>Realized Cap <span style="color:rgba(0,0,0,0.4);border:none"> (of all UTXOs where age≥155 days)</span></span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 短期持有者 MVRV Ratio -->
          <div v-if="prop1 == `B04-1-12`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>STH-MVRV =</div>
                    <div>
                        <span>Market Cap <span style="color:rgba(0,0,0,0.4)">(of all UTXOs where age ＜ 155 days)</span> </span>
                        <span>Realized Cap <span style="color:rgba(0,0,0,0.4);border:none"> (of all UTXOs where age ＜ 155 days)</span></span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 流通市值 -->
          <div v-if="prop1 == `B05-1-1`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.7)">Market Cap = price <span style="color:rgba(0,0,0,0.4)"> [USD]</span><span>·</span> Total Supply</p>
            </el-row>
        </div>
        <!-- 已实现流通市值 -->
          <div v-if="prop1 == `B05-1-17`">
            <el-row type="flex" justify="center">
                <p class="formulaRow" >
                    Realized Cap = value · price  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <span class="created">created</span>         
                    
                <span style="color:rgba(0,0,0,0.4)" >[USD] (of all UTXOs)</span> 
                </p>
           </el-row>
        </div>
        <!-- 新的MVRV 改名 MVRV Ratio -->
          <div v-if="prop1 == `B05-1-3`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>MVRV =</div>
                    <div>
                        <span>Market Cap </span>
                        <span>Realized Cap</span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- MVRV Z-Score -->
          <div v-if="prop1 == `B05-1-4`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>MVRV-Z Score =</div>
                    <div>
                        <span>Market Cap - Realized Cap</span>
                        <span>Standard Deviation <span style="color:rgba(0,0,0,0.4);border:none">(Market Cap)</span> </span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 流通速度 -->
          <div v-if="prop1 == `B05-1-2`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Velocity =</div>
                    <div>
                        <span>1</span>
                        <span> NVT Ratio </span>
                    </div>
                    &nbsp;          
                    =
                    <div>
                        <span>Transaction Volume <span style="color:rgba(0,0,0,0.4)">[USD]</span></span>
                        <span>Market Cap <span style="color:rgba(0,0,0,0.4);border:none">[USD]</span></span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 已实现盈利量 -->
          <div v-if="prop1 == `B05-1-5`" style="position: relative;">
            <el-row type="flex" justify="center">
                <p class="indexBox" style="font-weight:550;color:rgba(0,0,0,0.6)">Realized Profit = value · (price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="indexs" >spent</span><span style="color:rgba(0,0,0,0.4)">[USD]</span>  - price  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="indexs2">created</span> &nbsp;<span style="color:rgba(0,0,0,0.4)">[USD]</span>)</p>
            </el-row>
           
            <p class="indexBox2" >(of all spent outputs where price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="formulaFont" style="left: 85%;">spent</span>  > price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="formulaFont2" style="left: 94.5%;">created</span>)</p>

        </div>
        <!-- 已实现亏损量 -->
          <div v-if="prop1 == `B05-1-6`" class="loss" style="position: relative;">
            <el-row type="flex" justify="center">
                <p class="indexBox" style="font-weight:550;color:rgba(0,0,0,0.6)">Realized Loss = value · (price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="indexs" >created</span><span style="color:rgba(0,0,0,0.4)">[USD]</span>  - price  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="indexs2">spent</span> &nbsp;<span style="color:rgba(0,0,0,0.4)">[USD]</span>)</p>
            </el-row>

            <p class="indexBox2" >(of all spent outputs where price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="formulaFont" style="left: 84.5%;">created</span>  > price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="formulaFont2" style="left: 95.2%;">spent</span>)</p>

        </div>
        <!-- 已实现净收益损失比 -->
          <div v-if="prop1 == `B05-1-7`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Realized Profit/Loss =</div>
                    <div>
                        <span> Realized Profit</span>
                        <span>Realized Loss</span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 已实现价格 -->
          <div v-if="prop1 == `B05-1-8`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Realized Price =</div>
                    <div>
                        <span>Realized Cap</span>
                        <span>circulating supply</span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 已平衡价格 -->
          <div v-if="prop1 == `B05-1-9`" style="position: relative;">
            <el-row type="flex" justify="center">
            <div class="formulaBox1">
                <div>TransferredPrice<span> <i>USD</i> </span> =</div>
                <div>
                    <p> &#x2211; (coindays destroyed · <span> <i>price</i></span>)</p>
                    <p> <span><i>days</i> </span> · supply</p>
                </div>
                </div>
                </el-row>
                <el-row type="flex" justify="center">
                <p style="font-weight:600;color:rgba(0,0,0,0.6);" class="formulaBox2"> BalancedPrice<i>USD</i>  = RealisedPrice<i>USD</i>&nbsp; 一 &nbsp;TransferredPrice<i>USD</i></p>
            </el-row>
        </div>
        <!-- 累积价值-销毁天数比 -->
          <div v-if="prop1 == `B05-1-10`">
            <el-row type="flex" justify="center">
            <div class="formulaBox1">
                <div>CVDD<span> <i>USD</i> </span> =</div>
                <div>
                    <p> &#x2211; (coin days destroyed · <span> <i>price</i></span>)</p>
                    <p> <span><i>days</i> </span> · 6000000</p>
                </div>
                </div>
                </el-row>
        </div>
        <!-- 未实现的净收益量 -->
          <div v-if="prop1 == `B05-1-12`" class="unrealizedGains" style="position: relative;">
            <el-row type="flex" justify="center" >
            <p class="indexBox" style="font-weight:550;color:rgba(0,0,0,0.6)">Unrealized Profit = value · (price <span style="color:rgba(0,0,0,0.4)">[USD]</span>  - price  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="indexs2">created</span> &nbsp;<span style="color:rgba(0,0,0,0.4)">[USD]</span>)</p>
       
            </el-row>

            <p class="indexBox2" >(of all UTXOs where price  > price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="formulaFont2" style="left: 94%;">created</span>)</p>

        </div>
        <!-- 未实现的净亏损量 -->
          <div v-if="prop1 ==  `B05-1-13`"  class="unrealizedLosses" style="position: relative;">
            <el-row type="flex" justify="center">
                <p class="indexBox" style="font-weight:550;color:rgba(0,0,0,0.6)">Unrealized Loss = value · (price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span class="indexs" >created</span><span style="color:rgba(0,0,0,0.4)">[USD]</span>  - price  <span style="color:rgba(0,0,0,0.4)">[USD]</span>)</p>
            
            </el-row>

            <p class="indexBox2" >(of all UTXOs where price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="formulaFont" style="left: 88%;">created</span>  > price)</p>

        </div>
        <!-- 未实现的净收益损失比 -->
          <div v-if="prop1 == `B05-1-11`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Net Unrealized Profit and Loss <i>(NUPL)</i>  =</div>
                    <div>
                        <span>Market Cap -Realixed Cap</span>
                        <span>Market Cap </span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 长持者未实现的净收益损失比 -->
          <div v-if="prop1 == `B05-1-14`" class="unrealizedLossRatio">
            <el-row type="flex" justify="center">
                <div class="formulaBox1">
                    <section>LTH-NUPL</section>
                    
                    <section class="right">              
                    <div> &nbsp; = LTH-Relative Unrealized Profit - LTH-Relative Unrealized Loss</div>
                    <div class="formula2">
                        <div class="formula2Left">=</div>          
                    <div class="right2">          
                        <p>LTH-Market Cap - LTH-Realized Cap</p>
                        <p>LTH-Market Cap</p>
                    </div>           
                    </div>
                    <div class="formula3">
                        <p>=</p>
                    <div class="right3">
                        <p>value · (price <span style="color:rgba(0,0,0,0.4);font-size:16px">[USD]</span> - price<span  style="font-size:12px">Created</span> <span style="color:rgba(0,0,0,0.4)">[USD]</span> ) <span>(of all UTXOs where age ≥ 155 days)</span> </p>
                        <p>value · price <span style="color:rgba(0,0,0,0.4)">[USD]</span> <span>(of all UTXOs where age ≥ 155 days)</span> </p>
                    </div>           
                    </div>
                    </section>
                 </div>
            </el-row>
        
        </div>
        <!-- 短持者未实现的净收益损失比 -->
          <div v-if="prop1 == `B05-1-15`" class="shortHolder41">
            <el-row type="flex" justify="center">
                <div class="formulaBox1">
                    <section>STH-NUPL</section>
                    
                    <section class="right">              
                    <div> &nbsp; = STH-Relative Unrealized Profit − STH-Relative Unrealized Loss</div>
                    <div class="formula2">
                        <p style="border:none">=</p>          
                    <div class="right2">          
                        <p>STH-Market Cap − STH-Realized Cap</p>
                        <p>STH-Market Cap</p>
                    </div>           
                    </div>
                    <div class="formula3">
                        <p>=</p>
                    <div class="right2">
                        <p>value · (price <span style="color:rgba(0,0,0,0.4);font-size:16px">[USD]</span> - price<span style="font-size:12px">Created</span> <span style="color:rgba(0,0,0,0.4)">[USD]</span> ) <span>(of all UTXOs where age ＜ 155 days)</span> </p>
                        <p>value · price <span style="color:rgba(0,0,0,0.4)">[USD]</span> <span>(of all UTXOs where age ＜ 155 days)</span> </p>
                    </div>           
                    </div>
                    </section>
                </div>
            </el-row>
        </div>
        <!-- 市盈率 -->
          <div v-if="prop1 == `B05-1-16`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>NVT Ratio =</div>
                    <div>
                        <span>Market Cap<span style="color:rgba(0,0,0,0.4)"> [USD]</span></span>
                        <span>Transaction Volume <span style="color:rgba(0,0,0,0.4);border:none"> [USD]</span></span>
                    </div>
                </section>
            </el-row>
        </div>
           <!-- NVT信号 -->
           <div v-if="prop1 == `B05-1-19`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>NVT Signal =</div>
                    <div>
                        <span>Market Cap<span style="color:rgba(0,0,0,0.4)"> [USD]</span></span>
                        <span>Transaction Volume <span style="color:rgba(0,0,0,0.4);border:none"> [USD] (90 day moving average)</span></span>
                    </div>
                </section>
            </el-row>
        </div>
        <!-- 已花费输出平均寿命 -->
          <div v-if="prop1 == `B06-1-1`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">ASOL = Mean{ lifespan <span style="color:rgba(0,0,0,0.4)">[days] (of all spent outputs) </span> }</p>
            </el-row>
        </div>
        <!-- 币天销毁量 -->
          <div v-if="prop1 == `B06-1-2`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">CDD = value · lifespan <span style="color:rgba(0,0,0,0.4)">[days] (of all spent outputs )</span> </p>
            </el-row>
            <el-row type="flex" justify="center">
            <section class="formulas">
                <div>Supply-Adjusted CDD =</div>
                <div>
                  <span> CDD</span>
                  <span> Total Supply</span>
                </div>
            </section>
   </el-row>
        </div>
        <!-- 已花费输出休眠平均天数 -->
          <div v-if="prop1 == `B06-1-4`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Dormancy =</div>
                    <div>
                        <span>CDD</span>
                        <span>Transaction Volume </span>
                    </div>
                </section>
            </el-row>        
        </div>
        <!-- 活跃度 -->
          <div v-if="prop1 == `B06-1-5`" class="Activity">
            <el-row type="flex" justify="center">
                    <div class="formulaBox1">
                        <section class="title">Liveliness</section>
                        
                        <section class="right">             
                        
                        <div class="formula2">
                            <p>=</p>          
                        <div class="right2">          
                            <p>Cumulative CDD</p>
                            <p>Cumulative Total Supply</p>
                        </div>           
                        </div>
                        <div class="formula3">
                            <p style="border:none">=</p>
                        <div class="right2">
                            <p>value · lifespan <span style="color:rgba(0,0,0,0.4);font-size:16px">[blocks](of all outputs ever spent)</span>  </p>
                            <p>value · lifespan   <span style="color:rgba(0,0,0,0.4)">[blocks] (of all outputs ever created)</span> </p>
                        </div>           
                        </div>
                        </section>
                    </div>
                </el-row>
        </div>
        <!-- 已实现盈利交易占比 -->
          <div v-if="prop1 == `B07-1-1`" class="profit49">
            <el-row type="flex" justify="center">
                    <div class="formulaBox1">
                <div>Percent UTXOs in Profit = 100· </div>
                <div>
                    <p> UTXOs in Profit</p>
                    <p style="padding: 0px;"> Number of UTXOs</p>
                </div>
                </div>

            </el-row>
        </div>
        <!-- 已花费输出盈利比 -->
          <div v-if="prop1 == `B07-1-2`">
            <div class="formulasBOXS">
                <el-row type="flex" justify="center"  >
                    <section class="formulas">
                        <div>SOPR =</div>
                        <div>
                            <span>value · price <span style="font-size:12px;color:rgba(0,0,0,0.5);border:none">Spent</span> <span style="color:rgba(0,0,0,0.4)"> [USD] (of all spent outputs)</span></span>
                            <span>value · price <span style="font-size:12px;color:rgba(0,0,0,0.5);border:none">Created</span> <span style="color:rgba(0,0,0,0.4)"> [USD] (of all spent outputs)</span>   </span>
                        </div>
                    </section>
                </el-row>
                <el-row type="flex" justify="center">
                    <section class="formulas">
                        <div>LTH-SOPR =</div>
                        <div>
                            <span>value · price <span style="font-size:12px;color:rgba(0,0,0,0.5);border:none">Spent</span> <span style="color:rgba(0,0,0,0.4)"> [USD] (of all spent outputs where age ≥ 155 days)</span></span>
                            <span>value · price <span style="font-size:12px;color:rgba(0,0,0,0.5);border:none">Created</span> <span style="color:rgba(0,0,0,0.4)"> [USD] (of all spent outputs where age ≥ 155 days)</span></span>
                        </div>
                    </section>
                </el-row>
                <el-row type="flex" justify="center">
                    <section class="formulas">
                        <div>STH-SOPR =</div>
                        <div>
                            <span>value · price <span style="font-size:12px;color:rgba(0,0,0,0.5);border:none">Spent</span> <span style="color:rgba(0,0,0,0.4)"> [USD] (of all spent outputs where age ＜ 155 days)</span></span>
                            <span>value · price <span style="font-size:12px;color:rgba(0,0,0,0.5);border:none">Created</span> <span style="color:rgba(0,0,0,0.4)"> [USD] (of all spent outputs where age ＜ 155 days)</span></span>
                        </div>
                    </section>
                </el-row>

                </div>

        </div>
        <!-- 江卓尔60日累计涨幅 -->
          <div v-if="prop1 == `2-1`" class="jiangZhuoer77">
            <div class="formulaBox">     
                <div class="formula">
                <div> {{ $t(`arh.jzr`) }} =</div>
                <div style="position: relative;"> <span class="Summation"> &sum;</span> &nbsp;&nbsp;&nbsp;   {{ $t(`home.Increase`) }}<span style="font-size:12px">t</span> </div>
                </div>
            </div>
        </div>
        <!-- 2年移动平均价格乘数 -->
          <div v-if="prop1 == `2-4`">
            <el-row type="flex" justify="center"> 
            <section class="formulaBox">       
                <div><i>Bitcoin Investor Tool = MA<span><i>730</i> </span> (BTC<span ><i>USD</i></span>) and MA<span>730*5</span> (BTC<span>USD</span> )</i></div>
            </section>
            </el-row>
        </div>
        <!-- PI周期顶指标 -->
          <div v-if="prop1 == `2-9`">
            <el-row type="flex" justify="center"> 
            <section class="formulaBox">
        
                <div><i>Pi Cycle Top Indicator = MA<span>350*2</span>(BTC<span>USD</span>) and MA<span>111</span>(BTC<span>USD</span>) </i></div>

            </section>
            </el-row>
        </div>
        <!-- 稳定币供应比 -->
          <div v-if="prop1 == `2-10`">
            <el-row type="flex" justify="center">
                    <section class="formulas">
                        <div>SSR =</div>
                        <div>
                            <span>Market Cap <span style="color:rgba(0,0,0,0.4)"> (of BTC)</span></span>
                            <span> Market Cap <span style="color:rgba(0,0,0,0.4);border:none"> (of all Stablecoins )</span></span>
                        </div>
                    </section>
                </el-row>
         </div>
         <!-- 稳定币供应比振荡器 -->
          <div v-if="prop1 == `2-11`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">SSR Oscillator = Bollinger_Bands(200,2)</p>
            </el-row>
        </div>
        <!-- 库存/新发行比 -->
          <div v-if="prop1 == `2-12`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">S/F = circulating supply/newly mined bitcoins</p>
            </el-row>
        </div>
        <!-- 库存/新发行偏差 -->
          <div v-if="prop1 == `2-13`">
            <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">S/F Deflection = Price/( circulating supply/newly mined bitcoins)</p>
            </el-row>
        </div>
        <!-- 黄金比例乘数 -->
          <div v-if="prop1 == `2-14`">
            <el-row type="flex" justify="center">
            <section class="formulaBox">      
                <div> <i>Golden Ratio Multiplier = MA<span>350</span>(BTC<span>USD</span>)</i> *(1.6,2,3,5,8,13,21) </div>

                </section>
            </el-row>
        </div>
        <!-- ETH--------------------------- -->
        <!-- 通货膨胀率 -->
          <div v-if="prop1 == `E02-1-8`">
            <el-row type="flex" justify="center">
                <section class="formulas">
                    <div>Inflation Rate =</div>
                    <div>
                        <span>new coins issued</span>
                        <span>current supply </span>
                    </div>
                </section>
            </el-row>
        </div>

        <!-- 货币供应量 宏观经济指标导航 -->
        <div v-if="prop1 == `H1-1`">
            <el-row type="flex" justify="center">
              <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">MB = {{ $t(`home.cash`) }} + {{ $t(`home.deposit`) }} </p>
            </el-row>
            </el-row>

            <el-row type="flex" justify="center">
              <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">M1 = {{ $t(`home.cash2`) }} + {{ $t(`home.current`) }} + {{ $t(`home.check`) }} + {{ $t(`home.depositCheck`) }}</p>
            </el-row>
            </el-row>

            <el-row type="flex" justify="center">
              <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">M2 = M1 + {{ $t(`home.savings`) }} + {{ $t(`home.regular`) }} + {{ $t(`home.otherDeposits`) }} </p>
            </el-row>
            </el-row>
        </div>
         <!-- 私人债务占GDP比重 -->
         <div v-if="prop1 == `3-8`">
            <el-row type="flex" justify="center">
              <el-row type="flex" justify="center">
                <p style="font-weight:550;color:rgba(0,0,0,0.6)">Private debt as a percentage of GDP = {{ $t(`home.private`) }} / {{ $t(`home.GDP`) }} </p>
            </el-row>
            </el-row>
        </div>

        
         
          
     


    </div>
</template>

<script>
export default {
    props: ["prop1","prop2"],
}
</script>

<style lang="scss" scoped>
.index:hover{
  font-weight: 600;
  color: #f7931a;
  text-decoration: underline;
  cursor: pointer;
}
// ------
.formulaRow {
  font-weight: 550;
  color: rgba(0, 0, 0, 0.6);
  // outline: 1px solid red;
  // height: 40px;
  position: relative;
  .created{
    position: absolute;
    left: 51%;
    font-size: 12px;
    top: 10px;
    color: rgba(0, 0, 0, 0.6);

  }
}

// ----------
.indexBox{
    // outline: 1px solid red;
    position: relative;
    margin-bottom: 20px;
    .indexs{
      font-size: 12px;
      position: absolute;
      left: 49.5%;
      top: 10px;
      color: rgba(0, 0, 0, 0.5);
    }
    .indexs2{
      font-size: 12px;
      position: absolute;
      left: 79%;
      top: 10px;
      color: rgba(0, 0, 0, 0.5);

    }
  }
  .indexBox2{
    position: relative;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.4);
    // outline: 1px solid red;
    box-sizing: border-box;
    padding-left: 43%;
    margin: 0px;
    position: absolute;
    top: 40px;
    // color: #f7931a;
    .formulaFont{
      position: absolute;
      left: 86%;
      font-size: 12px;
      top: 10px;
    }
    .formulaFont2{
      position: absolute;
      left: 95%;
      font-size: 12px;
      top: 10px;

    }

  }
//   ----------------
.loss{

    .indexBox{
    // outline: 1px solid red;
    position: relative;
    margin-bottom: 20px;
    .indexs{
      font-size: 12px;
      position: absolute;
      left: 48%;
      top: 10px;
      color: rgba(0, 0, 0, 0.5);
    }
    .indexs2{
      font-size: 12px;
      position: absolute;
      left: 80%;
      top: 10px;
      color: rgba(0, 0, 0, 0.5);

    }
  }
  .indexBox2{
    position: relative;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.4);
    // outline: 1px solid red;
    box-sizing: border-box;
    padding-left: 43%;
    margin: 0px;
    position: absolute;
    top: 40px;
    .formulaFont{
      position: absolute;
      left: 86%;
      font-size: 12px;
      top: 10px;
    }
    .formulaFont2{
      position: absolute;
      left: 96%;
      font-size: 12px;
      top: 10px;

    }

  }

}
// -------------
.formulaBox1{
    // outline: 1px solid red;
    display: flex;
    padding: 0px 10px;
    font-weight: 600;
    div{
      // outline: 1px solid red;
      color: rgba(0, 0, 0, 0.6);

    }
    div:nth-of-type(1){
      font-size: 18px;
      font-weight: 600;
      span{
        font-size: 12px;
        font-weight: normal;
        // outline: 1px solid red;
        

      }
    }
    div:nth-of-type(2){
      display: flex;
      flex-direction: column;
      p{
        margin: 0px;
        // outline: 1px solid red;
      }
      p:nth-of-type(1){
        border-bottom: 1px solid rgba(0, 0, 0, 0.6);
      }

      p:nth-of-type(2){
        padding-left: 90px;
      }
      span{
        font-size: 16px;
        font-weight: 500;
      }
    
    }
  }
  .formulaBox2{  i{
      font-size: 12px;
      font-weight: 500;
      }}
//   -------------
.unrealizedGains{

    .indexBox{
    // outline: 1px solid red;
    position: relative;
    margin-bottom: 20px;
    .indexs{
      font-size: 12px;
      position: absolute;
      left: 48%;
      top: 10px;
      color: rgba(0, 0, 0, 0.5);
    }
    .indexs2{
      font-size: 12px;
      position: absolute;
      left: 78%;
      top: 10px;
      color: rgba(0, 0, 0, 0.5);

    }
  }
  .indexBox2{
    position: relative;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.4);
    // outline: 1px solid red;
    box-sizing: border-box;
    padding-left: 45%;
    margin: 0px;
    position: absolute;
    top: 40px;
    .formulaFont{
      position: absolute;
      left: 86%;
      font-size: 12px;
      top: 10px;
    }
    .formulaFont2{
      position: absolute;
      left: 94.5%;
      font-size: 12px;
      top: 10px;

    }

  }

}

// ---------------
.unrealizedLosses{
    .indexBox{
    // outline: 1px solid red;
    position: relative;
    margin-bottom: 20px;
    .indexs{
      font-size: 12px;
      position: absolute;
      left: 54%;
      top: 10px;
      color: rgba(0, 0, 0, 0.5);
    }
    .indexs2{
      font-size: 12px;
      position: absolute;
      left: 78%;
      top: 10px;
      color: rgba(0, 0, 0, 0.5);

    }
  }
  .indexBox2{
    position: relative;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.4);
    // outline: 1px solid red;    
    box-sizing: border-box;
    padding-left: 45%;
    margin: 0px;
    position: absolute;
    top: 40px;
    .formulaFont{
      position: absolute;
      left: 88.5%;
      font-size: 12px;
      top: 10px;
    }
    .formulaFont2{
      position: absolute;
      left: 94.5%;
      font-size: 12px;
      top: 10px;

    }

  }


}
// ------------------
.unrealizedLossRatio{
    position: relative;
 .formulaBox1{
//   outline: 1px solid red;
//   display: flex;
  // margin-top: 10px;
  // outline: 1px solid red;
font-weight: 600;
color: rgba(0, 0, 0, 0.6);
 margin-bottom: 20px;
  .section{
    outline: 1px solid red;
  }
  .right{
    // outline: 1px solid red;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    p{
      padding: 0;
     
    }
    div{
      // margin-top: 5px;
      // outline: 1px solid goldenrod;
    }
    .formula2{
        padding: 0px 10px;
        display: flex;
        align-items: center;
        //   outline: 1px solid red;     
        // background: #f7931a;
        flex-direction: row;
        .formula2Left{
            width: 20px;
            // outline: 1px solid red;
        }
        p{
          padding: 0;
        //   outline: 1px solid red;
        //   border: none;
        }
       
        .right2{
            // background: green;
          padding: 0px 5px;
          p:nth-of-type(1){
          border-bottom: 1px solid rgba(0, 0, 0, 0.7);
          margin: 0px;
        }
        p:nth-of-type(2){
          padding-left: 80px;
          // outline: 1px solid red;
          margin: 0px;
        }
        }
      }
      .formula3{
        padding: 0px 10px;
        display: flex;
        align-items: center;
        p{
          padding: 0;
        }
       
        .right3{
          padding: 0px 5px;
          p:nth-of-type(1){
          border-bottom: 1px solid rgba(0, 0, 0, 0.7);
          margin: 0px;
          span{
            color: rgba(0, 0, 0, 0.4);
          }
          span:nth-of-type(1){
            font-size: 12px;
            margin: 0px;
          }
        }
        p:nth-of-type(2){
          padding-left: 80px;
          margin: 0px;
          span{
            color: rgba(0, 0, 0, 0.4);
          }
        }
        }
      }
  }


}


}
// ------------------

.shortHolder41{

    .formulaBox1{
  // outline: 1px solid red;
  display: flex;
  // margin-top: 10px;
  // outline: 1px solid red;
font-weight: 600;
color: rgba(0, 0, 0, 0.6);
 margin-bottom: 20px;
  .section{
    outline: 1px solid red;
  }
  .right{
    // outline: 1px solid red;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    p{
      padding: 0;
     
    }
    div{
      // margin-top: 5px;
      // outline: 1px solid goldenrod;
    }
    .formula2{
        padding: 0px 10px;
        display: flex;
        align-items: center;
         flex-direction: row;
        p{
          padding: 0;
          // outline: 1px solid red;
        }
       
        .right2{
          padding: 0px 5px;
          p:nth-of-type(1){
          border-bottom: 1px solid rgba(0, 0, 0, 0.7);
          margin: 0px;
        }
        p:nth-of-type(2){
          padding-left: 80px;
          // outline: 1px solid red;
          margin: 0px;
        }
        }
      }
      .formula3{
        padding: 0px 10px;
        display: flex;
        align-items: center;
        p{
          padding: 0;
        }
       
        .right2{
          padding: 0px 5px;
          p:nth-of-type(1){
          border-bottom: 1px solid rgba(0, 0, 0, 0.7);
          margin: 0px;
          span{
            color: rgba(0, 0, 0, 0.4);
          }
          span:nth-of-type(1){
            font-size: 12px;
            margin: 0px;
          }
        }
        p:nth-of-type(2){
          padding-left: 80px;
          margin: 0px;
          span{
            color: rgba(0, 0, 0, 0.4);
          }
        }
        }
      }
  }


}

}
// -------------------
.Activity{

    .formulaBox1{
  // outline: 1px solid red;
  display: flex;
  // margin-top: 10px;
  // outline: 1px solid red;
font-weight: 600;
color: rgba(0, 0, 0, 0.6);
 margin-bottom: 20px;

 
  .title{
    // outline: 1px solid red;
    padding-top: 15px;
  }
  .right{
    // outline: 1px solid red;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
   
    p{
      padding: 0;
     
    }
    div{
      // margin-top: 5px;
      // outline: 1px solid goldenrod;
    }
    .formula2{
        padding: 0px 10px;
        display: flex;
        align-items: center;
        p{
          padding: 0;
          // outline: 1px solid red;
        }
       
        .right2{
          padding: 0px 5px;
          p:nth-of-type(1){
          border-bottom: 1px solid rgba(0, 0, 0, 0.7);
          margin: 0px;
        }
        p:nth-of-type(2){
          // padding-left: 80px;
          // outline: 1px solid red;
          margin: 0px;
        }
        }
      }
      .formula3{
        padding: 0px 10px;
        display: flex;
        align-items: center;
        flex-direction: row;
        p{
          padding: 0;
        }
       
        .right2{
          padding: 0px 5px;
          p:nth-of-type(1){
          border-bottom: 1px solid rgba(0, 0, 0, 0.7);
          margin: 0px;
          span{
            color: rgba(0, 0, 0, 0.4);
          }
          span:nth-of-type(1){
            font-size: 12px;
            margin: 0px;
          }
        }
        p:nth-of-type(2){
          // padding-left: 80px;
          margin: 0px;
          span{
            color: rgba(0, 0, 0, 0.4);
          }
        }
        }
      }
  }


}

}
// ---------------
.profit49{
    .formulaBox1{
    // outline: 1px solid red;
    display: flex;
    padding: 0px 10px;
    align-items: center;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 600;
    
    div{
      // outline: 1px solid red;
      color: rgba(0, 0, 0, 0.6);
    }
    div:nth-of-type(1){
      font-size: 16px;
      // font-weight: 600;
      span{
        font-size: 12px;
        font-weight: normal;
        // outline: 1px solid red;
      

      }
    }
    div:nth-of-type(2){
      display: flex;
      flex-direction: column;
      margin-left: 5px;
      p{
        margin: 0px;
        // outline: 1px solid red;
      }
      p:nth-of-type(1){
        border-bottom: 1px solid rgba(0, 0, 0, 0.6);
      }

      // p:nth-of-type(2){
      //   padding-left: 90px;
      // }
      span{
        font-size: 16px;
      }
    
    }
  }
}

// -----------------------------
.formulasBOXS{
  // outline: 1px solid red;
 display: flex;
 flex-direction: column;
 justify-content: start;
 align-items: flex-start;
 padding-left: 28%;
 .formulas{
  margin-top: 10px;
 }
}
// -----------------
.jiangZhuoer77{
    .formulaBox {
  width: 98.7%;
  padding: 10px 0px;
  margin-bottom: -30px;
  // height: 60px;
  // background: #e5e5e5;
  color: rgba(0, 0, 0, 0.7);
  position: relative;
  
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  p{
    padding: 0px 10px;
  }
  .formula{
    display: flex;
    // outline: 1px solid red;
    padding: 0px 10px;
 
  }
  .Summation:after{
      content: "60";
      font-size: 12px;
      position: absolute;
      top: -3px;
    }
    .Summation:before{
      content: "t=1";
      font-size: 12px;
      position: absolute;
      top: 10px;
      left: 12px;
    }
}

}
</style>